import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  useRuntimeConfig: false,
  apiUrl: "https://brickhub-api.katdev.com/api",
  appName: "Brickhub",
  version: "1.0.0",
  logLevel: "debug",
  loginUrl: "https://storefront-brickhub.katdev.com/auth/login",
  explorePropertiesUrl: "https://storefront-brickhub.katdev.com/project-list",
  propertyDetailsUrl: "https://storefront-brickhub.katdev.com/property-details",
  // Session test config (15-min access token scenario):
  // - JWT warning at 10 min → sessionExpiryWarningMs = 4 min before 14 min logout
  // - Inactivity: warning after 10 min idle, auto logout 4 min later (14 min total)
  inactivityTimeout: 840000,
  warningTimeout: 240000,
  sessionExpiryWarningMs: 240000,
  authFlowDebug: true,
  digilockerAllowLocalhostRedirect: false,
  digilockerLocalTunnelUrl: '' as string,
  digilockerRedirectUrl:
    'https://storefront-brickhub.katdev.com/digilocker-complete?digilocker_return=1',
  //firebase web configuration
  firebase: {
    apiKey: 'AIzaSyB7NTD-2lPsZLAM9uTI78vddjRWp4AdTuY',
    authDomain: 'brickhub-67e4e.firebaseapp.com',
    projectId: 'brickhub-67e4e',
    storageBucket: 'brickhub-67e4e.firebasestorage.app',
    messagingSenderId: '616180042921',
    appId: '1:616180042921:web:c908ed57483808d394adb8',
    vapidKey: 'BPssdTJDIWpoyW5kE8chVQk4GV_k5FeLDiakiS2Y6o4loFHmlfF1S1VGvtyB56m0Sno5bNXoTJt31DYndlCtGMg',
  },
};
